const comm100 = [
  {
    campaignId: 411,
    instanceId: 1000616,
    vueUrl: 'https://vue.comm100.com/livechat.ashx?siteId=',
    standbyUrl: 'https://standby.comm100vue.com/livechat.ashx?siteId=',
  },
];

export default comm100;
